<template>
  <div>
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content">
      <h2>领取详情</h2>
      <h3>数据筛选</h3>
      <div>
        <el-form
          :inline="true"
          :model="searchForm"
          ref="searchForm"
          class="search-form"
          size="small"
        >
          <el-form-item label="用户信息" prop="userName">
            <el-input
              v-model="searchForm.userName"
              placeholder="请输入用户信息"
            ></el-input>
          </el-form-item>
          <el-form-item label="领取时间" prop="getTime">
            <el-date-picker
              v-model="searchForm.getTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
              :clearable="false"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="来源平台" prop="platformId">
            <el-select
              v-model="searchForm.platformId"
              placeholder="请选择来源平台"
              filterable
              clearable
            >
              <el-option
                v-for="item in platformList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="fetchData('search')"
              >查询</el-button
            >
            <el-button type="primary" plain @click="fetchData('reset')"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <div style="display: flex; align-items: center">
          <h3 style="margin-bottom: 0">列表数据</h3>
        </div>
        <div>
          <el-button type="primary" @click="exportFn">导出</el-button>
        </div>
      </div>
      <div id="base-list">
        <lb-table
          v-horizontal-scroll="'always'"
          :column="columns"
          :data="list"
          pagination
          :total="page.totalNum"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="searchForm.pageNo"
          :page-size="searchForm.pageSize"
          @selection-change="onMultipleSelection"
          @size-change="handleSizeChange"
          @p-current-change="handleCurrentChange"
        >
        </lb-table>
      </div>
    </div>
  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    breadcrumbTop,
    LbTable
  },
  data () {
    return {
      dataList: {
        list: [
          { title: '矩阵管理', path: '', type: '0' },
          { title: '平台优惠券管理', path: '', type: '1' }
        ]
      },
      searchForm: {
        couponId: '',
        userName: '',
        getTimeEnd: '',
        getTimeStart: '',
        platformId: null,
        getTime: [],
        pageNo: 1,
        pageSize: 10
      },
      list: [],
      columns: [
        { type: 'selection', minWidth: '80', fixed: 'left' },
        { label: '领取时间', prop: 'getTime', minWidth: '120' },
        {
          label: '用户信息', prop: 'name', minWidth: '120',
          render: (h, scope) => {
            return (
              <div>
                <p style='text-align:left;'>{scope.row.userName}(ID：{scope.row.userId})</p>
                <p style='text-align:left;'>{scope.row.phone}</p>
              </div>
            )
          }
        },
        { label: '来源平台', prop: 'platformName', minWidth: '120' },
        { label: '已领取', prop: 'hasNum', minWidth: '120' },
        { label: '已使用', prop: 'useNum', minWidth: '120' },
        { label: '已过期（已失效）', prop: 'expireNum', minWidth: '120' },
        { label: '未使用', prop: 'unUseNum', minWidth: '120' }
      ],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      loading: true,
      platformList: []
    }
  },
  created () {
    this.goodsPlatforms()
    this.getList()
  },
  mounted () {

  },
  methods: {
    fetchData (type) {
      this.searchForm.pageNo = 1;
      if (type == 'reset') {
        this.$refs['searchForm'].resetFields()
      }
      this.getList()
    },
    goodsPlatforms () {
      const params = {
        userId: null,
        username: null,
        phone: null,
        vipLevel: null,
        categoryIds: null,
        openTimeStart: null,
        openTimeEnd: null,
        status: 1
      }
      this.$api.goodsPlatforms(params).then((res) => {
        this.platformList = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    //导出
    exportFn () {
      if (this.searchForm.getTime.length > 0) {
        this.searchForm.getTimeStart = this.searchForm.getTime[0]
        this.searchForm.getTimeEnd = this.searchForm.getTime[1]
      } else {
        this.searchForm.getTimeStart = ''
        this.searchForm.getTimeEnd = ''
      }
      this.axios.post('/ps/psCoupon/exportGetList', this.searchForm)
        .then(res => {
          if (res.code == 0) {
            this.downloadlink(res.data)
            this.$message({
              type: 'success',
              message: '导出成功!'
            })
          }
        })
    },
    downloadlink (url) {
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = url
      document.body.appendChild(iframe)
    },
    onMultipleSelection (val) {
      this.selectionGoods = val
    },
    handleCurrentChange (currentChange) {
      this.searchForm.pageNo = currentChange
      this.getList()
    },
    handleSizeChange (sizeChange) {
      this.searchForm.pageSize = sizeChange
      this.getList()
    },
    getList () {
      this.searchForm.couponId = this.$route.query.id
      if (this.searchForm.getTime.length > 0) {
        this.searchForm.getTimeStart = this.searchForm.getTime[0]
        this.searchForm.getTimeEnd = this.searchForm.getTime[1]
      } else {
        this.searchForm.getTimeStart = ''
        this.searchForm.getTimeEnd = ''
      }
      this.axios.post('/ps/psCoupon/getGetPageList', this.searchForm)
        .then(res => {
          console.log(res)
          this.loading = false;
          if (res.code == 0) {
            this.list = res.data.list;
            this.page.totalNum = res.data.totalNum;
          }
        })

    },

    add (type, id) {
      if (type == 'look') {
        this.$router.push({
          name: 'lookPlatform',
          query: {
            type: type,
            id: id
          }
        })
      } else {
        this.$router.push({
          name: 'platListDetail',
          query: {
            type: type,
            id: id
          }
        })
      }

    },
    setting () {
      this.$router.push({
        name: 'settingPlatform',
        query: {}
      })
    }
  }
}
</script>
<style  lang="scss">
.el-cascader-panel {
  .el-scrollbar:first-child {
    .el-checkbox {
      display: none;
    }
  }
}
</style>
<style scoped lang="scss">
::v-deep .el-cascader-panel:first-child .el-checkbox {
  display: none !important;
}

::v-deep .el-cascader-panel li[aria-haspopup] .el-checkbox {
  display: none !important;
}

.container {
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding: 5px;
}

.title {
  display: flex;
  justify-content: space-between;
}

#base-list {
  margin-top: 20px;
}

:deep(
    #base-list
      .lb-table
      .el-table
      .el-table__body
      .el-table__row
      .el-table__cell:last-child
      .cell
      div
  ) {
  display: inline-block;

  a {
    margin: 0 5px;
  }
}

.search-form {
  display: flex;
  flex-wrap: wrap;

  .el-form-item {
    /deep/ .el-form-item__label {
      width: 82px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }

    /deep/ .el-form-item__content {
      display: block;
      margin-left: 82px;

      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }
}
</style>
  
  